import { render, staticRenderFns } from "./InterForm.vue?vue&type=template&id=ca284438&scoped=true&"
import script from "./InterForm.vue?vue&type=script&lang=js&"
export * from "./InterForm.vue?vue&type=script&lang=js&"
import style0 from "./InterForm.vue?vue&type=style&index=0&id=ca284438&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca284438",
  null
  
)

export default component.exports